<template>
    <div id='mobile_sub_menu_container' class='mobile-sub-menu-container closed'>
        <div @click='toggleMobileSubMenu'><i class="fa-solid fa-angle-left"></i> Back</div>
         <div class='sub-categories-mobile-container'>
            <div v-for='sub_heading in selected_heading.sub_headings' :key='sub_heading.id' class='column'>
                <div class='sub-heading' @click='selectedMenuItem(sub_heading.sef_url)'>{{sub_heading.name}}</div>
                <div v-for='menu_item in sub_heading.menu_items' :key='menu_item.id'>
                    <div class='menu-item' @click='selectedMenuItem(menu_item.sef_url)'>{{menu_item.name}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['open_sub_menu', 'selected_heading'],
    methods:{
        toggleMobileSubMenu(){
            const container = document.querySelector(`#mobile_sub_menu_container`);
            container.classList.toggle('open');
            container.classList.toggle('closed');
        },
        selectedMenuItem(url){
            this.$emit('selectedMenuItemListener', url);
        },
    },
    watch:{
        'open_sub_menu': function(){
            this.toggleMobileSubMenu();
        }
    }
}
</script>

<style lang="scss" scoped>
.mobile-sub-menu-container{
	position: absolute;
	top: 0;
	left: -20px;
	width: 100%;
	height: 100dvh;
	z-index: 101;
    background-color: #040711;
	color: white;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0px 20px;
}

.mobile-sub-menu-container.open{
	transform: translateX(-0%);
    transition: 0.7s;
    transition: transform 330ms ease-in-out;
}

.mobile-sub-menu-container.closed{
	transform: translateX(110%);
    transition: 0.7s;
    transition: transform 330ms ease-in-out;
}

.sub-categories-mobile-container{
    height: 100%;
    padding: 0px 20px;
}

.sub-heading{
    font-size: 1rem;
    font-weight: 600;
    margin-bottom: 5px;
    cursor: pointer;
    text-transform: uppercase;
    margin-top: 20px;
}

.menu-item{
    font-size: 0.9rem;
    cursor: pointer;
    color: #495057;
    margin-bottom: 3px;
}
</style>